// File: src/components/home/HowItWorks.jsx
import React, { useState } from 'react';
import '../../styles/home/HowItWorks.css';

const HowItWorks = () => {
  const [activeProcess, setActiveProcess] = useState('buy');

  const buyingSteps = [
    { number: '01', title: 'Browse & Search', description: 'Browse our vast inventory and find your perfect car with advanced filters.', icon: '🔍' },
    { number: '02', title: 'Book Test Drive', description: 'Schedule a test drive at your convenience — doorstep or at our hub.', icon: '🚗' },
    { number: '03', title: 'Secure Payment', description: 'Make a safe online payment or choose flexible financing options.', icon: '💳' },
    { number: '04', title: 'Get Delivery', description: 'Receive your car at your doorstep, fully documented and ready.', icon: '🏠' },
  ];

  const sellingSteps = [
    { number: '01', title: 'Get Instant Quote', description: 'Enter your car details and receive an instant price estimate.', icon: '💰' },
    { number: '02', title: 'Schedule Inspection', description: 'Our expert inspects your car at your location — with transparent pricing.', icon: '✅' },
    { number: '03', title: 'Accept Offer', description: 'Get the best price offer and accept instantly — no haggling.', icon: '🤝' },
    { number: '04', title: 'Instant Payment', description: 'Get paid immediately after documentation is complete.', icon: '💵' },
  ];

  const steps = activeProcess === 'buy' ? buyingSteps : sellingSteps;

  return (
    <section className="how-it-works-section">
      <div className="hiw-bg-grid" />

      <div className="hiw-container">
        {/* Header */}
        <div className="hiw-header">
          <span className="hiw-eyebrow">✦ Simple Process</span>
          <h2 className="hiw-title">How It Works</h2>
          <p className="hiw-subtitle">Simple, transparent, and designed around you.</p>
        </div>

        {/* Toggle */}
        <div className="process-toggle">
          <button
            className={`toggle-btn ${activeProcess === 'buy' ? 'active' : ''}`}
            onClick={() => setActiveProcess('buy')}
          >
            <span className="toggle-icon">🚗</span> Buying a Car
          </button>
          <button
            className={`toggle-btn ${activeProcess === 'sell' ? 'active' : ''}`}
            onClick={() => setActiveProcess('sell')}
          >
            <span className="toggle-icon">💰</span> Selling a Car
          </button>
        </div>

        {/* Steps */}
        <div className="steps-container" key={activeProcess}>
          {steps.map((step, index) => (
            <div key={index} className="step-card" style={{ '--i': index }}>
              {/* connector line */}
              {index < steps.length - 1 && <div className="step-connector" />}

              <div className="step-number-badge">{step.number}</div>
              <div className="step-icon-wrap">
                <span className="step-icon">{step.icon}</span>
              </div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-desc">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;